import type {
  DeviceViewElementType,
  DeviceViewEntityId,
  DeviceViewNodeId,
} from 'components/DeviceView/deviceViewTypes';

/**
 * Determine whether a device view structure refers to node
 *
 * There are many structures in device view containing element type and according entity id.
 * As there is no universal generic/pattern over this, but we have to resolve what kind of id
 * is contained in given structure, we can use this universal function to narrow the type.
 */
export const isDeviceViewNodeStructure = (deviceViewStructure: {
  deviceViewElement?: DeviceViewElementType;
  deviceViewEntityId?: DeviceViewEntityId | null;
}): deviceViewStructure is {
  deviceViewElement: 'node';
  deviceViewEntityId: DeviceViewNodeId;
} => deviceViewStructure.deviceViewElement === 'node';
